import HttpRequest from "../HttpRequest";

export default class CRUDService {

  httpRequest = new HttpRequest();

  getBaseURL() {
    throw new Error('Implements this')
  };

  save(entity) {
    if (entity.id) {
      return this.httpRequest.put(this.getBaseURL() + entity.id, entity);
    } else {
      return this.httpRequest.post(this.getBaseURL(), entity);
    }
  }

  findById(id) {
    return this.httpRequest.get(this.getBaseURL() + id);
  }

  deleteById(id) {
    return this.httpRequest.delete(this.getBaseURL() + id);
  }

  findAll(page, pageSize) {
    return this.httpRequest.get(this.getBaseURL() + `?page=${page}&size=${pageSize}`);
  }

  getHttpRequest() {
    return this.httpRequest;
  }

}



// WEBPACK FOOTER //
// ./src/services/base/CRUDService.js